var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state_rating_score > 0)?_c('b-rating',{attrs:{"border":true,"icons":_vm.state_icon,"max":_vm.state_rating_max,"score":_vm.state_rating_score}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }